import { EnumOption } from './enum-option';

export const AddressSuiteType = {
  Apartment: 0,
  Suite: 1,
  Floor: 2,
};

export const AddressSuiteTypeList: EnumOption[] = [
  { value: AddressSuiteType.Apartment, label: 'Apt.' },
  { value: AddressSuiteType.Suite, label: 'Ste.' },
  { value: AddressSuiteType.Floor, label: 'Flr.' },
];
